import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/FormCheckboxListInput.module.scss';

const EnrollmentFormCheckboxListInput = ({ name, id, label, value, defaultValue, max, inputRef }) => {
  const maxSelected = (event) => {
    if (!max) {
      return;
    }
    const choices = document.getElementsByName(name);
    let checked = 0;
    for (let i = 0; i < choices.length; i++) {
      if (choices.item(i).checked) {
        checked += 1;
      }
      if (checked > max) {
        event.target.checked = false;
      }
    }
  };

  return (
    <label htmlFor={id} className={styles.EnrollmentFormCheckboxListInput}>
      <input
        name={name}
        id={id}
        type="checkbox"
        value={value}
        defaultChecked={defaultValue && defaultValue[value]}
        ref={inputRef}
        onChange={maxSelected}
      />
      <span className={styles.option}>{label}</span>
      <div className={styles.checkedBackground} />
    </label>
  );
};

EnrollmentFormCheckboxListInput.defaultProps = {
  defaultValue: null,
  max: null,
};

EnrollmentFormCheckboxListInput.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  defaultValue: PropTypes.shape({}),
  max: PropTypes.number,
  inputRef: PropTypes.func.isRequired,
};

export default EnrollmentFormCheckboxListInput;
